import Vue from "vue";

// What the header's WhatsApp button and the whatsapp_click event need to know
// about the page the customer is on. Pages set it as they load; the layout
// clears it on every route change.
export const pageContext = Vue.observable({
  // Short suburb name ("Killara"), for the prefilled WhatsApp messages
  suburb: null,
  // Location slug, sent as booking_location
  location: null,
  // 1 | 2 | 3 | "thank_you" | null
  step: null,
  // Header button's data-wa-source / message
  headerSource: "booking_header",
});

export function resetPageContext() {
  pageContext.suburb = null;
  pageContext.location = null;
  pageContext.step = null;
  pageContext.headerSource = "booking_header";
}
